// 获取验证图片  以及token
export function reqGet(data) {
  const { post } = useUseRequest()
  return post(`/code`, data)
}

// 滑动或者点选验证
export function reqCheck(data) {
  const { post } = useUseRequest()
  return post(`/check`, data)
}
